import { useState } from 'react';
import 'tippy.js/dist/tippy.css';
import './style.css';
import { useEffect } from 'react';
import { iso } from '../../../../../../components/iso';
import Load from '../../../../../../components/load';
import descriptorsJSON from "../../../../../../components/age-rating-descriptions.json"
import AgeRating from '../../../../../../components/movie/age-rating';
import { convertDateTmdb } from '../../../../../../components/convert-date';

export default function Others( { movie_data, movie_data_db, movie_id_imdb } ) {

    const [ loading, setLoading ] = useState(false);
    const [exchangeRate, setExchangeRate] = useState(null);
    const [ coin, setCoin ] = useState('dolar');
    const [ budget, setBudget ] = useState(0);
    const [ revenue, setRevenue ] = useState(0);

    useEffect(()=>{
        if (exchangeRate?.bid) {
            if (coin == 'dolar') {
                setBudget(movie_data?.budget)
                setRevenue(movie_data?.revenue)
            } else {
                setBudget(movie_data?.budget * exchangeRate?.bid)
                setRevenue(movie_data?.revenue * exchangeRate?.bid)
            }
        }

    }, [ coin, exchangeRate ])

    useEffect(() => {
        async function fetchExchangeRate() {
        try {
            const response = await fetch('https://economia.awesomeapi.com.br/json/last/USD-BRL');
            const data = await response.json();
            setExchangeRate(data?.USDBRL);
        } catch (error) {
            console.error('Erro ao buscar a taxa de câmbio:', error);
        }}

        fetchExchangeRate();
    }, []);

    useEffect(()=>{

        setLoading(true);

        if (movie_data && movie_data_db) {
            setLoading(false);
        }
        
    }, [ movie_id_imdb, movie_data, movie_data_db ]);

    const statusToBr = (status) => {
        switch (status) {
            case 'Rumored':
                return 'Rumor';
            case 'Planned':
                return 'Planejado';
            case 'In Production':
                return 'Em Produção';
            case 'Post Production':
                return 'Ainda não lançado';
            case 'Released':
                return 'Lançado(a)';
            case 'Canceled':
                return 'Cancelado(a)';
            case 'Returning Series':
                return 'Série em Continuação';
            case 'Pilot':
                return 'Piloto';
            case 'Ended':
                return 'Finalizado(a)';
            case 'Returning':
                return 'Retornando';
            default:
                return status;
        }
    };

    const unidades = ['zero', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove'];
    const dezenas = ['', 'Dez', 'Vinte', 'Trinta', 'Quarenta', 'Cinquenta', 'Sessenta', 'Setenta', 'Oitenta', 'Noventa'];
    const especiais = ['onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
    const centenas = ['Cem', 'Cento', 'Duzentos', 'Trezentos', 'Quatrocentos', 'Quinhentos', 'Seiscentos', 'Setecentos', 'Oitocentos', 'Novecentos'];

    const numeroPorExtenso = (numero) => {
        if (numero === 0) return 'zero';
        
        const milhar = (num) => {
            if (num < 1000) return '';
            if (num === 1000) return 'mil';
            return numeroPorExtenso(Math.floor(num / 1000)) + ' mil' + (num % 1000 ? ' ' + numeroPorExtenso(num % 1000) : '');
        };
        
        const milhao = (num) => {
            if (num < 1000000) return milhar(num);
            if (num === 1000000) return 'um milhão';
            return numeroPorExtenso(Math.floor(num / 1000000)) + ' milhões' + (num % 1000000 ? ' ' + milhar(num % 1000000) : '');
        };
        
        const bilhao = (num) => {
            if (num < 1000000000) return milhao(num);
            if (num === 1000000000) return 'um bilhão';
            return numeroPorExtenso(Math.floor(num / 1000000000)) + ' bilhões' + (num % 1000000000 ? ' ' + milhao(num % 1000000000) : '');
        };

        if (numero < 10) return unidades[numero];
        if (numero < 20) return especiais[numero - 11];
        if (numero < 100) return dezenas[Math.floor(numero / 10)] + (numero % 10 ? ' e ' + unidades[numero % 10] : '');
        if (numero < 1000) return centenas[Math.floor(numero / 100)] + (numero % 100 ? ' e ' + numeroPorExtenso(numero % 100) : '');
        if (numero < 1000000) return milhar(numero);
        if (numero < 1000000000) return milhao(numero);
        return bilhao(numero);
    };

    const principalPorExtenso = (numero) => {
        if (numero >= 1000000000) {
            return numeroPorExtenso(Math.floor(numero / 1000000000)) + ' bilhões';
        } else if (numero >= 1000000) {
            return numeroPorExtenso(Math.floor(numero / 1000000)) + ' milhões';
        } else if (numero >= 1000) {
            return numeroPorExtenso(Math.floor(numero / 1000)) + ' mil';
        } else {
            return numeroPorExtenso(numero);
        }
    };
    
    return (
        <div>
            {(loading || !exchangeRate) ?
                <Load align_center={true}/>
            :
                <div className='content'>
                    <section className='section-info'>
                        <h3 className='title'>Classificação: <span className='span-age-rating'><AgeRating age_rating={movie_data_db?.age_rating?.age[0]} /></span></h3>
                        {movie_data_db?.age_rating?.descriptors?.map((descriptor, index, array) => {
                            return (
                                <span key={index} className='description'>
                                    - {descriptorsJSON[descriptor]}
                                </span>
                            );
                        })}
                    </section>
                    {(movie_data?.number_of_seasons && movie_data?.number_of_seasons) &&
                        <section className='section-info'>
                            <h3 className='title'>Temporadas e episódios</h3>
                            <p className='description'>{movie_data?.number_of_seasons} Temporadas e {movie_data?.number_of_episodes} Episódios</p>
                        </section>
                    }
                    {(movie_data?.first_air_date) &&
                        <section className='section-info'>
                            <h3 className='title'>Data de lançamento</h3>
                            <p className='description'>{convertDateTmdb(movie_data?.first_air_date)}</p>
                        </section>
                    }
                    {movie_data?.release_date &&
                        <section className='section-info'>
                            <h3 className='title'>Data de lançamento</h3>
                            <p className='description'>{movie_data?.release_date.slice(8, 10)}/{movie_data?.release_date.slice(5, 7)}/{movie_data?.release_date.slice(0, 4)}</p>
                        </section>
                    }
                    {movie_data?.status &&
                        <section className='section-info'>
                            <h3 className='title'>Status</h3>
                            <p className='description'>{statusToBr(movie_data?.status)}</p>
                        </section>
                    }
                    {(movie_data?.original_name || movie_data?.original_title) &&
                        <section className='section-info'>
                            <h3 className='title'>Título original</h3>
                            <p className='description'>{movie_data?.original_name}{movie_data?.original_title}</p>
                        </section>
                    }
                    {movie_data?.original_language &&
                        <section className='section-info'>
                            <h3 className='title'>Idioma original</h3>
                            <p className='description'>{iso[movie_data?.original_language]}</p>
                        </section>
                    }
                    {(movie_data?.last_air_date && movie_data?.last_episode_to_air) &&
                        <section className='section-info'>
                            <h3 className='title'>Ultimo episódio lançado:</h3>
                            <p className='description'>{movie_data?.last_episode_to_air.name} | Temporada {movie_data?.last_episode_to_air.season_number} Episódio {movie_data?.last_episode_to_air.episode_number}</p>
                            <p className='description'>{movie_data?.last_air_date.slice(8, 10)}/{movie_data?.last_air_date.slice(5, 7)}/{movie_data?.last_air_date.slice(0, 4)}</p>
                        </section>
                    }
                    {movie_data?.next_episode_to_air &&
                        <section className='section-info'>
                            <h3 className='title'>Próximo episódio</h3>
                            <p className='description'>{movie_data?.next_episode_to_air.name} | Temporada {movie_data?.next_episode_to_air.season_number} Episódio {movie_data?.next_episode_to_air.episode_number}</p>
                            <p className='description'>{movie_data?.next_episode_to_air.air_date.slice(8, 10)}/{movie_data?.next_episode_to_air.air_date.slice(5, 7)}/{movie_data?.next_episode_to_air.air_date.slice(0, 4)}</p>
                        </section>
                    }
                    
                    {movie_data?.homepage &&
                        <section className='section-info'>
                            <h3 className='title'>Site oficial</h3>
                            <a href={movie_data?.homepage} target='_blank'>{movie_data?.homepage}</a>
                        </section>
                    }
                    {movie_id_imdb &&
                        <section className='section-info'>
                            <h3 className='title'>Imdb | <p> {movie_id_imdb}</p></h3>
                            <a href={`https://www.imdb.com/title/${movie_id_imdb}/`} target='_blank'>{`https://www.imdb.com/title/${movie_id_imdb}/`}</a>
                        </section>
                    }
                    {movie_data?.id &&
                        <section className='section-info'>
                            <h3 className='title'>The Movie Database  <p> | {movie_data?.id}</p></h3>
                            <a href={`https://www.themoviedb.org/${movie_data?.name ? 'tv' : 'movie'}/${movie_data?.id}/`} target='_blank'>{`https://www.themoviedb.org/${movie_data?.name ? 'tv' : 'movie'}/${movie_data?.id}/`}</a>
                        </section>
                    }
                    {((budget > 0 || revenue > 0)) &&
                        <div className='container-budget-revenue'>
                            <div className='change-coin'>
                                <button onClick={()=> coin == 'dolar' ? setCoin('real') : setCoin('dolar')}><i className='fas fa-repeat'></i> {coin == 'dolar' ? "Real" : "Dólar"}</button>
                            </div>
                            <section className='content-budget-revenue'>
                                {(budget > 0) &&
                                    <div>
                                        <p><strong>Orçamento: </strong>{budget ? `${(budget).toLocaleString('pt-BR', { style: 'currency', currency: coin == 'dolar' ? 'USD' : 'BRL' })}` : ''}</p>
                                        <span>({principalPorExtenso(budget)})</span>
                                    </div>
                                }
                                {(revenue > 0) &&
                                    <div>
                                        <p><strong>Receita: </strong>{revenue ? `${(revenue).toLocaleString('pt-BR', { style: 'currency', currency: coin == 'dolar' ? 'USD' : 'BRL' })}` : ''}</p>
                                        <span>({principalPorExtenso(revenue)})</span>
                                    </div>
                                }
                            </section>
                        </div>
                    }
                    {movie_data?.tagline &&
                        <section className='section-slogan'>
                            <p>"{movie_data?.tagline}"</p>
                        </section>
                    }
                </div>
            }
        </div>
    )
}